import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AppLayout from "@/components/AppLayout";
import DashboardPage from "@/pages/DashboardPage";
import ContactsPage from "@/pages/ContactsPage";
import ImportCsvPage from "@/pages/ImportCsvPage";
import ListsPage from "@/pages/ListsPage";
import TemplatesPage from "@/pages/TemplatesPage";
import CampaignsPage from "@/pages/CampaignsPage";
import CampaignEditorPage from "@/pages/CampaignEditorPage";
import CampaignReportPage from "@/pages/CampaignReportPage";
import SettingsPage from "@/pages/SettingsPage";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground">
        Caricamento…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/login"
            element={
              <PublicOnly>
                <LoginPage />
              </PublicOnly>
            }
          />
          <Route
            path="/registrati"
            element={
              <PublicOnly>
                <RegisterPage />
              </PublicOnly>
            }
          />
          <Route
            element={
              <Protected>
                <AppLayout />
              </Protected>
            }
          >
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/contatti" element={<ContactsPage />} />
            <Route path="/contatti/importa" element={<ImportCsvPage />} />
            <Route path="/liste" element={<ListsPage />} />
            <Route path="/template" element={<TemplatesPage />} />
            <Route path="/campagne" element={<CampaignsPage />} />
            <Route path="/campagne/nuova" element={<CampaignEditorPage />} />
            <Route path="/campagne/:id" element={<CampaignEditorPage />} />
            <Route path="/campagne/:id/report" element={<CampaignReportPage />} />
            <Route path="/impostazioni" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
